import { render, staticRenderFns } from "./PlanejamentoAcaoFormModalServico.vue?vue&type=template&id=a3e48f84"
import script from "./PlanejamentoAcaoFormModalServico.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoFormModalServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports